import { attendance } from "../client";

export const getHistoricalAttendance = (params) => {
  const user = {
    flag: "getStudentAttendanceDetails",
    parameters: {
      getStudentMarks: params,
    },
  };
  return attendance.post("/get/all/student/attendance/historical", user);
};

export const getHistoricalMarks = (params) => {
  const user = {
    flag: "getMarks",
    parameters: {
      getStudentMarks: params,
    },
  };
  return attendance.post("/get/all/semester/marks/historical", user);
};
